import { useEffect, useState } from "react";

const KEY = "bb_delivery_online";

/**
 * UI-only online/offline persistence (no backend endpoint).
 * Broadcasts via storage event so multiple tabs stay in sync.
 */
export function useDeliveryStatus() {
  const [online, setOnline] = useState(() => localStorage.getItem(KEY) !== "0");

  useEffect(() => {
    const handler = (e) => { if (e.key === KEY) setOnline(e.newValue !== "0"); };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);

  const toggle = (next) => {
    const val = next === undefined ? !online : !!next;
    localStorage.setItem(KEY, val ? "1" : "0");
    setOnline(val);
  };

  return { online, toggle };
}
